'use strict';

var pReduce = require('p-reduce');

var is = require('@sindresorhus/is');

module.exports = function (iterable) {
  var ret = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var task = _step.value;
      var type = is(task);

      if (type !== 'Function') {
        return Promise.reject(new TypeError("Expected task to be a `Function`, received `".concat(type, "`")));
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return pReduce(iterable, function (_, fn) {
    return Promise.resolve().then(fn).then(function (val) {
      ret.push(val);
    });
  }).then(function () {
    return ret;
  });
};